document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortby', (sectionId, defaultColumns = 4, useHashFilterUrls = false) => ({
    t: '',
    show: false,
    showFilterAside: true,
    loading: false,
    isDesktop: false,
    listLayout: false,
    desktopColumns: defaultColumns || 4,
    sortOpen: false,
    currentSort: '',
    currentSortLabel: '',
    activeDesktopFilter: '',
    useHashFilterUrls: Boolean(useHashFilterUrls),
    cachedResults: [],
    searchParamsPrev: '',
    searchParamsInitial: '',
    init() {
      const hashParams = this._hashParamsFromHash();
      const legacyParams = this._hashParamsFromCombined(window.location.search.slice(1));
      const locationParams = this._readLocationSearchParams();
      this.searchParamsPrev = locationParams;
      this.searchParamsInitial = locationParams;

      const savedCols = localStorage.getItem("product-grid-columns");
      if (savedCols && !isNaN(savedCols) && Number(savedCols) >= 2 && Number(savedCols) <= 5) {
        this.desktopColumns = Number(savedCols);
      } else {
        this.desktopColumns = Number(defaultColumns) || 4;
      }
      this._initLayout();
      this._setListeners();
      this._initSort();
      this._applyGridColumns();
      this.$nextTick(() => {
        this._ensureActiveDesktopFilter();
        this._setLayoutControlAvailability();
        this._prepareHashPaginationLinks();
      });

      if (this.useHashFilterUrls) {
        if (hashParams.toString() || legacyParams.toString()) {
          this._updateURLHash(locationParams, true);
        }
        // Hash fragments are not sent to Shopify, so restore their state through
        // the same section-rendering endpoint used for interactive filtering.
        if (hashParams.toString()) this._renderPage(locationParams, false);
      }
    },
    setColumns(count) {
      this.desktopColumns = Number(count);
      localStorage.setItem("product-grid-columns", this.desktopColumns);
      this._applyGridColumns();
    },
    _applyGridColumns() {
      const grid = document.getElementById('items-grid');
      if (grid) {
        grid.style.setProperty('--pg-columns-desktop', this.desktopColumns);
      }
    },
    _initSort() {
      const select = document.getElementById('FormSelectFilter');
      if (select) {
        this.currentSort = select.value;
        const selectedOption = select.options[select.selectedIndex];
        if (selectedOption) {
          this.currentSortLabel = selectedOption.text.trim();
        }
      }
    },
    selectSortOption(val, label) {
      this.currentSort = val;
      this.currentSortLabel = label;
      this.sortOpen = false;
      const selectDesktop = document.getElementById('FormSelectFilter');
      if (selectDesktop) {
        selectDesktop.value = val;
      }
      const formDrawer = document.getElementById('FacetFiltersForm');
      if (formDrawer) {
        const selectMobile = formDrawer.querySelector('select[name="sort_by"]');
        if (selectMobile) {
          selectMobile.value = val;
        }
      }
      this.onSubmit(0);
    },
    setActiveDesktopFilter(filterKey, focus = false) {
      this.activeDesktopFilter = filterKey;
      if (focus) {
        this.$nextTick(() => {
          this.$root.querySelector(`[data-pg-filter-tab="${filterKey}"]`)?.focus();
        });
      }
    },
    handleDesktopFilterTabKey(event) {
      const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      if (!keys.includes(event.key)) return;
      const tabs = Array.from(event.currentTarget.querySelectorAll('[data-pg-filter-tab]'));
      if (!tabs.length) return;
      event.preventDefault();
      const currentIndex = Math.max(0, tabs.indexOf(document.activeElement));
      let nextIndex = currentIndex;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      this.setActiveDesktopFilter(tabs[nextIndex].dataset.pgFilterTab, true);
    },
    _ensureActiveDesktopFilter() {
      const tabs = Array.from(this.$root.querySelectorAll('[data-pg-filter-tab]'));
      if (!tabs.length) {
        this.activeDesktopFilter = '';
        return;
      }
      if (!tabs.some(tab => tab.dataset.pgFilterTab === this.activeDesktopFilter)) {
        this.activeDesktopFilter = tabs[0].dataset.pgFilterTab;
      }
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (window.innerWidth > 767) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
      this._setLayoutControlAvailability();
    },
    _setControlsEnabled(container, enabled) {
      if (!container) return;
      container.querySelectorAll('input, select, button[data-facet-submit]').forEach(control => {
        if (!enabled && !control.disabled) {
          control.disabled = true;
          control.dataset.pgLayoutDisabled = 'true';
        } else if (enabled && control.dataset.pgLayoutDisabled === 'true') {
          control.disabled = false;
          delete control.dataset.pgLayoutDisabled;
        }
      });
    },
    _setLayoutControlAvailability() {
      if (!this.$root) return;
      const formAside = this.$root.querySelector('.form-aside');
      const formDrawer = this.$root.querySelector('.form-drawer');
      const desktopControls = this.$root.querySelector('#FacetsWrapperDesktop');
      const desktopUsesDrawer = this.isDesktop && !formAside;
      this._setControlsEnabled(formAside, this.isDesktop);
      this._setControlsEnabled(desktopControls, this.isDesktop);
      this._setControlsEnabled(formDrawer, !this.isDesktop || desktopUsesDrawer);
      if (this.isDesktop) this._setControlsEnabled(formDrawer?.querySelector('.pg-mobile-sort-section'), false);
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = this.useHashFilterUrls
          ? this._readLocationSearchParams()
          : (event.state?.searchParams ?? window.location.search.slice(1));
        if (searchParams === this.searchParamsPrev) return;
        this._renderPage(searchParams, false);
      }
      window.addEventListener('popstate', onHistoryChange);
      if (this.useHashFilterUrls) window.addEventListener('hashchange', onHistoryChange);

      if (this.useHashFilterUrls) {
        this.$root.addEventListener('click', (event) => {
          const link = event.target.closest('#ProductGridContainer .pagination a[href]');
          if (!link || !this.$root.contains(link)) return;
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const target = new URL(link.href, window.location.href);
          const targetParams = new URLSearchParams(target.search);
          const currentHashParams = this._hashParamsFromCombined(this.searchParamsPrev);
          this._deleteHashParams(targetParams);
          currentHashParams.forEach((value, key) => targetParams.append(key, value));
          localStorage.setItem('autofocus', 'true');
          this._renderPage(targetParams.toString());
        });
      }

      installMediaQueryWatcher('(min-width: 768px)', (matches) => this._initLayout());
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      this._reloadFilter(url);
    },
    clearFilters() {
      const params = new URLSearchParams(this.searchParamsPrev);
      this._deleteFilterParams(params);
      params.delete('page');
      this._renderPage(params.toString());
    },
    renderPagination() {
      var formData = {
        'attributes': {
          'collection-pagination': this.$el.value             
        }
      }; 
      fetch(Shopify.routes.root+'cart/update', {
        method:'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData)
      }).then(() => {
        this.cachedResults = [];
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
      }); 
    },
    onSubmit(wait = 500) {
      clearTimeout(this.t);

      const func = () => {
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
        if(this.isDesktop) document.getElementById('FormSelectFilter')?.blur();
      }
      
      this.t = setTimeout(() => {
        func();
      }, wait);
    },
    rangePrice(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");
      let priceGap = 1;

      rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          e.preventDefault();
          let minVal = Number(rangeInput[0].value).toFixed(2),
            maxVal = Number(rangeInput[1].value).toFixed(2);
          
          if (maxVal - minVal < priceGap) {
            if (e.target.className === "range-min") {
              rangeInput[0].value = maxVal - priceGap;
              priceInput[0].value = maxVal - priceGap;
            } else {
              rangeInput[1].value = minVal + priceGap;
              priceInput[1].value = maxVal + priceGap;
            }
          } else {
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
            range.style.setProperty('--right_range', 100 - (maxVal / rangeInput[1].max) * 100 + '%');
          }
          pricePreview[0].textContent = minVal;
          pricePreview[1].textContent = maxVal;
        });
      });
    },
    initRange(el) {
      const rangeInput = el.querySelectorAll(".range-input input"),
      range = el.querySelector(".slider .progress");
      
      let minVal = Number(rangeInput[0].value).toFixed(2),
      maxVal = Number(rangeInput[1].value).toFixed(2);
      range.style.setProperty('--left_range', (minVal / rangeInput[0].max) * 100 + '%');
      range.style.setProperty('--right_range',100 - (maxVal / rangeInput[1].max) * 100 + '%');
    },
    _reloadFilter(url) {
      const searchParams = url.indexOf('?') == -1 ? '' : url.slice(url.indexOf('?') + 1);
      this._renderPage(searchParams);
    },
    _createSearchParams(form) {
      if (!form) return '';
      const formData = new FormData(form);
      return new URLSearchParams(formData).toString();
    },
    _isFilterParam(key) {
      return key.startsWith('filter.');
    },
    _isHashParam(key) {
      return this._isFilterParam(key) || key === 'sort_by';
    },
    _deleteFilterParams(params) {
      Array.from(params.keys()).forEach(key => {
        if (this._isFilterParam(key)) params.delete(key);
      });
      return params;
    },
    _deleteHashParams(params) {
      Array.from(params.keys()).forEach(key => {
        if (this._isHashParam(key)) params.delete(key);
      });
      return params;
    },
    _filterParamsFromCombined(searchParams) {
      const filters = new URLSearchParams();
      new URLSearchParams(searchParams).forEach((value, key) => {
        if (this._isFilterParam(key)) filters.append(key, value);
      });
      return filters;
    },
    _hashParamsFromCombined(searchParams) {
      const source = new URLSearchParams(searchParams);
      const hashParams = new URLSearchParams();
      source.getAll('sort_by').forEach(value => hashParams.append('sort_by', value));
      source.forEach((value, key) => {
        if (this._isFilterParam(key)) hashParams.append(key, value);
      });
      return hashParams;
    },
    _filterParamsFromSearch() {
      return this._filterParamsFromCombined(window.location.search.slice(1));
    },
    _filterParamsFromHash() {
      const rawHash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : '';
      return this._filterParamsFromCombined(rawHash);
    },
    _hashParamsFromHash() {
      const rawHash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : '';
      return this._hashParamsFromCombined(rawHash);
    },
    _readLocationSearchParams() {
      const query = new URLSearchParams(window.location.search);
      if (!this.useHashFilterUrls) return query.toString();
      const hashParams = this._hashParamsFromHash();
      const legacyParams = this._hashParamsFromCombined(query.toString());
      this._deleteHashParams(query);
      const selectedParams = hashParams.toString() ? hashParams : legacyParams;
      selectedParams.forEach((value, key) => query.append(key, value));
      return query.toString();
    },
    _visibleURL(searchParams) {
      if (!this.useHashFilterUrls) {
        return `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`;
      }
      const query = new URLSearchParams(searchParams);
      const hashParams = this._hashParamsFromCombined(searchParams);
      this._deleteHashParams(query);
      const queryString = query.toString();
      let hashString = hashParams.toString();
      if (!hashString && !this._hashParamsFromHash().toString()) {
        const currentHash = window.location.hash.startsWith('#') ? window.location.hash.slice(1) : '';
        if (currentHash && !this._hashParamsFromCombined(currentHash).toString()) hashString = currentHash;
      }
      return `${window.location.pathname}${queryString ? `?${queryString}` : ''}${hashString ? `#${hashString}` : ''}`;
    },
    _updateURLHash(searchParams, replace = false) {
      const method = replace ? 'replaceState' : 'pushState';
      history[method]({ searchParams }, '', this._visibleURL(searchParams));
    },
    _renderPage(searchParams, updateURLHash = true) {
      this.searchParamsPrev = searchParams;
      this.loading = true;
      
      if (this.cachedResults[searchParams]) {
        if (updateURLHash) this._updateURLHash(searchParams);
        this._renderResults(this.cachedResults[searchParams]);
        return;
      }

      const requestParams = new URLSearchParams(searchParams);
      requestParams.set('section_id', sectionId);
      const url = `${window.location.pathname}?${requestParams.toString()}`;
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          this.cachedResults[searchParams] = html;
          this._renderResults(html);
          document.dispatchEvent(new CustomEvent("eurus:collection:reloaded"));
        })
        .catch((err) => {
          console.error("Error fetching filtered results:", err);
          this.loading = false;
        });

      if (updateURLHash) this._updateURLHash(searchParams);
    },
    _renderResults(html) {
      try {
        this._renderFilters(html);
        this._renderProductGridContainer(html);
        this._renderProductCount(html);
        this._initSort();
        this._applyGridColumns();
        this._ensureActiveDesktopFilter();
        this._setLayoutControlAvailability();
        this._prepareHashPaginationLinks();
      } catch (err) {
        console.error("Error rendering facet results:", err);
      } finally {
        this.loading = false;
      }
    },
    _renderFilters(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      this._renderDesktopFilterControls(parsedHTML);
      let blockFiltesDrawer = '.form-drawer';
      let blockFiltesAside = '.form-aside';
      const selectBlockFiltesDrawer = this.$root.querySelector(blockFiltesDrawer);
      const selectBlockFiltesAside = this.$root.querySelector(blockFiltesAside);
      let activeTag = this.$root.querySelector("#active-filter-tag");

      if (activeTag && parsedHTML.getElementById("active-filter-tag")) {
        activeTag.innerHTML = parsedHTML.getElementById("active-filter-tag").innerHTML;   
      }
      if (selectBlockFiltesDrawer && parsedHTML.querySelector(blockFiltesDrawer)) {
        if (this.$el && this.$el.id) {  
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesDrawer.innerHTML = parsedHTML.querySelector(blockFiltesDrawer).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      if (selectBlockFiltesAside && parsedHTML.querySelector(blockFiltesAside)) {
        if (this.$el && this.$el.id) {
          const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
          if (eleOpening) {
            eleOpening.setAttribute('x-data', '{open: true}');
            parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
          }
        }
        selectBlockFiltesAside.innerHTML = parsedHTML.querySelector(blockFiltesAside).innerHTML;
        this._renderAdditionalElements(parsedHTML);
      };
      this._renderAdvancedFilters(parsedHTML);
    },
    _renderDesktopFilterControls(parsedHTML) {
      const destination = this.$root.querySelector('#FacetsWrapperDesktop .pg-controls-left');
      if (!destination?.querySelector('.pg-pill-filter-shell')) return;
      const teleport = parsedHTML.querySelector('template[x-teleport="#header-filter"]');
      const source = teleport?.content?.querySelector('#FacetsWrapperDesktop .pg-controls-left');
      if (destination && source) destination.innerHTML = source.innerHTML;
    },
    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll(".filter-advanced");
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destinationEl, index) => {
          if (source[index]) {
            destinationEl.innerHTML = source[index].innerHTML;
          }
        });
      }
    },
    _renderProductGridContainer(html) {
      const newGridContainer = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
      const currentGridContainer = document.getElementById('ProductGridContainer');
      if (currentGridContainer && newGridContainer) {
        currentGridContainer.innerHTML = newGridContainer.innerHTML;
      }
      this._applyGridColumns();
    },
    _prepareHashPaginationLinks() {
      if (!this.useHashFilterUrls || !this.$root) return;
      const currentHashParams = this._hashParamsFromCombined(this.searchParamsPrev);
      this.$root.querySelectorAll('#ProductGridContainer .pagination a[href]').forEach(link => {
        const target = new URL(link.getAttribute('href'), window.location.href);
        const params = new URLSearchParams(target.search);
        const linkHashParams = this._hashParamsFromCombined(params.toString());
        this._deleteHashParams(params);
        const hashParams = linkHashParams.toString() ? linkHashParams : currentHashParams;
        hashParams.forEach((value, key) => params.append(key, value));
        link.setAttribute('href', this._visibleURL(params.toString()));
      });
    },
    _renderProductCount(html) {
      const productCountEl = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const containerDrawer = document.getElementById('ProductCountDrawer');
        if (container) {
          container.innerHTML = count;
          container.classList.remove('loading');
        }
        if (containerDrawer) {
          containerDrawer.innerHTML = count;
        }
      }
    },
    _renderAdditionalElements(html) {
      const container = document.getElementById('ProductPerPage');
      const source = html.getElementById('ProductPerPage');
      if (container && source) {
        container.innerHTML = source.innerHTML;
      }
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
    },
    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },
    setFilterHeaderHeight() {
      const header = document.getElementById('header-filter');
      if (header) document.documentElement.style.setProperty('--height-sticky-filter', header.offsetHeight + 'px');
    },
    setPositionOptionFilter(el) {
      if (!el) return;
      const elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      if (!elPopup) return;
      const viewportWidth = window.xViewport?.innerWidth || window.innerWidth;
      const spacingRight = viewportWidth - elRect.left;
      const elWidth = elPopup.offsetWidth || el.offsetWidth || 300;
      const checkSpacing = spacingRight - elWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
        elPopup.style.right = 'auto';
      } else {
        elPopup.style.left = checkSpacing + 'px';
        elPopup.style.right = 'auto';
      }
    },
    getPopupPosition(el) {
      this.$nextTick(() => {
        if (!el) return;
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          const viewportWidth = window.xViewport?.innerWidth || window.innerWidth;
          if (popupRect.right > viewportWidth) {
            elPopup.style.left = 'auto';
            elPopup.style.right = '0px';
          }
        }
      });
    }
  }));
});
